import React, { useState } from "react";

// 헤더 타입별 색상 정의
const headerColors = {
  AH: "#ff4d4d", // Red
  PH_PRESENTATION: "#ff66cc", // Pink (Presentation 계층 PH)
  PH_SESSION: "#a64dff", // Purple (Session 계층 PH)
  TH: "#4da6ff", // Blue
  NH: "#00cc99", // Green
  DH: "#ffcc00", // Yellow
  BIT: "#4a4a4a", // Dark Gray
  DATA: "#000000", // Black
};

// 패킷별 상세 정보 정의
const packetInfo = {
  AH: "Application Header \n 사용자와 네트워크 간의 인터페이스를\n 제공하며 데이터를 생성.",
  PH_PRESENTATION: "Presentation Header \n 데이터를 특정 형식으로 변환하거나\n 암호화/복호화를 수행.",
  PH_SESSION: "Session Header \n 통신 세션을 설정, 관리, 종료하는 데\n 필요한 정보를 포함.",
  TH: "Transport Header \n 데이터의 신뢰성을 보장하고,\n 패킷 재전송 및 순서 제어를 담당.",
  NH: "Network Header \n 데이터의 경로를 설정하고 라우팅을 수행.",
  DH: "Data Link Header \n 노드 간 데이터 전송과 에러 감지를 담당.",
  BIT: "Binary Data \n 물리 계층을 통해 전송되는\n 비트 단위 데이터.",
  DATA: "Payload Data \n 상위 계층에서 생성된 최종 데이터로,\n 전송해야 할 핵심 데이터 내용.",
};

const BuildUpPacket = ({ highlightedLayer }) => {
  const [selectedPacket, setSelectedPacket] = useState(null);

  const packetData = {
    application: ["AH", "DATA"],
    presentation: ["PH_PRESENTATION", "AH", "DATA"],
    session: ["PH_SESSION", "PH_PRESENTATION", "AH", "DATA"],
    transport: ["TH", "PH_SESSION", "PH_PRESENTATION", "AH", "DATA"],
    network: ["NH", "TH", "PH_SESSION", "PH_PRESENTATION", "AH", "DATA"],
    dataLink: ["DH", "NH", "TH", "PH_SESSION", "PH_PRESENTATION", "AH", "DATA", "DH"],
    physical: ["BIT"],
  };

  // 패킷 클릭 시 정보 표시
  const handlePacketClick = (packet) => {
    setSelectedPacket(packet);
  };

  const containerStyle = {
    textAlign: "center",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
  };

  const rowStyle = (isHighlighted) => ({
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    backgroundColor: isHighlighted ? "lightblue" : "white",
    padding: "5px",
    borderRadius: "4px",
    transition: "background-color 0.3s ease",
  });

  const boxStyle = (packet) => ({
    border: "2px solid black",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    cursor: "pointer",
    borderRadius: "5px",
    backgroundColor: headerColors[packet] || "gray",
    color: packet === "DATA" ? "white" : "black",
    transition: "border-color 0.3s ease",
    animation: highlightedLayer ? "pulse 1.5s infinite" : "none",
  });

  const bitStyle = {
    ...boxStyle("BIT"),
    width: "400px", // 가로 길이 증가
    padding: "12px 20px", // 패딩 조정
    fontSize: "16px", // 글꼴 크기 증가
    textAlign: "center", // 텍스트 정렬
  };

  const highlightPacket = (layer, packet) =>
    highlightedLayer === layer && packetData[layer]?.includes(packet);

  return (
    <div style={containerStyle}>
      <h2>Build-Up Packet</h2>
      {Object.entries(packetData).map(([layer, packets], index) => (
        <div key={index} style={rowStyle(layer === highlightedLayer)}>
          {packets.map((packet, idx) => (
            <div
              key={idx}
              style={{
                ...(packet === "BIT" ? bitStyle : boxStyle(packet)),
                borderColor: highlightPacket(layer, packet) ? "orange" : "black",
              }}
              onClick={() => handlePacketClick(packet)}
            >
              {/* UI에서는 모든 PH를 동일하게 "PH"로 표시 */}
              {packet.startsWith("PH_") ? "PH" : packet}
            </div>
          ))}
        </div>
      ))}

      {/* 패킷 정보 팝업 */}
      {selectedPacket && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "300px",
            textAlign: "center",
            zIndex: 1000,
          }}
        >
          <h3>Packet Info</h3>
          <p style={{ whiteSpace: "pre-line" }}>
            <strong>
              {selectedPacket.startsWith("PH_") ? "PH" : selectedPacket}
            </strong>
          </p>
          <p style={{ whiteSpace: "pre-line" }}>
            {packetInfo[selectedPacket] ||
              "No additional information available."}
          </p>
          <button
            onClick={() => setSelectedPacket(null)}
            style={{
              padding: "10px 15px",
              backgroundColor: "#e63946",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "14px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#c92a2a")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#e63946")}
          >
            닫기
          </button>
        </div>
      )}
    </div>
  );
};

export default BuildUpPacket;
